import type { FC } from 'react';
import { SkeletonBox } from '@presentation/components';
import * as Styled from '../styled';

export const Skeleton: FC = () => {
  return (
    <Styled.SkeletonWrapper>
      <Styled.BreederPicSkeleton />
      <Styled.SkeletonContainer>
        <SkeletonBox style={{ width: '30%', height: '22px', marginBottom: '5px' }} />
        <SkeletonBox style={{ width: '70%', height: '22px', marginBottom: '15px' }} />
        <SkeletonBox style={{ width: '20%', height: '16px', marginBottom: '15px' }} />
      </Styled.SkeletonContainer>
    </Styled.SkeletonWrapper>
  );
};
